//
//
//
//
//
//
//
//
import axios from 'axios';
import { Loading } from 'vant';
export default {
  // 使用时请使用 :url.sync=""传值
  props: {
    url: {
      required: true
    }
  },
  data: function data() {
    return {
      loading: true,
      html: ''
    };
  },
  watch: {
    url: function url(value) {
      this.load(value);
    }
  },
  mounted: function mounted() {
    this.load(this.url);
  },
  methods: {
    load: function load(url) {
      var _this = this;

      if (url && url.length > 0) {
        var param = {
          accept: 'text/html,text/plain'
        };
        axios.get(url).then(function (response) {
          setTimeout(function () {
            _this.loading = false;
          }, 1000); // 处理HTML显示

          _this.html = response.data;
        }).catch(function () {
          _this.loading = false;
          _this.html = '加载失败';
        });
      }
    }
  }
};